export default "__VITE_ASSET__Ck4Qzvsc__"